import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders} from '@angular/common/http';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})

export class RestapiService {
  
  apiHost:string = environment.backendUrl;
  uploadZipHost:string = environment.FronetndUrl;

    baseUrl:string = this.apiHost+"/api/v1/";
    uploadZipHostbaseUrl:string = this.uploadZipHost+"/api/v1/";

    constructor( private httpClient : HttpClient) { }
    public GetBasePath(){
      return this.apiHost;
    }
    public GetFEBasePath(){
      return this.uploadZipHost;
    }

    
    public getDefaultHeroBanner(){
      let bannerArray=['assets/img/catalog/Game-Banner-1.jpeg','assets/img/catalog/Game-Banner-2.jpeg','assets/img/catalog/Game-Banner-3.jpeg','assets/img/catalog/Game-Banner-4.jpeg']
      var heroBanner = bannerArray[Math.floor(Math.random()*bannerArray.length)];
      return heroBanner
    }

    public loggedIn(): boolean {
      return sessionStorage.getItem('auth_token')?true:false;
    }

    public postMethod(functionName:any,data: any) {
      const headers = new HttpHeaders(
        {
        'Content-Type':'application/json; charset=utf-8',
        'Authorization': ''+sessionStorage.getItem('auth_token')
        }
        );
        return new Promise( async(resolve, reject) => {
            await this.httpClient.post(this.baseUrl+functionName,data,{headers: headers}).subscribe(
               responsedata => {
                let response:any =responsedata
                if(response.code == 401){
                  sessionStorage.clear() 
                  window.location.replace('/login');
                }else{
                  resolve(response) 
                }
                 
               },
               error => {
                resolve(error.message)
               }
             );
           });
    }

    public async getMethod(functionName: any) {
      const headers = new HttpHeaders(
        {
        'Content-Type':'application/json; charset=utf-8',
        'Authorization': ''+sessionStorage.getItem('auth_token')
        }
        );

      
        return new Promise( async(resolve, reject) => {
         await this.httpClient.get(this.baseUrl+functionName,{headers: headers}).subscribe(
            responsedata => {
              let response:any =responsedata
                if(response.code == 401){
                  sessionStorage.clear() 
                  window.location.replace('/login');
                }else{
                  resolve(response) 
                }
              
            },
            error => {
             resolve(error.message)
            }
          );
        });
    }
    
    public uploadMethod(functionName:any,data: any) {
      const headers = new HttpHeaders(
        {
        'Accept':'application/json',
        'Authorization': ''+sessionStorage.getItem('auth_token')
        }
        );
        return new Promise( async(resolve, reject) => {
          
            await this.httpClient.post(this.uploadZipHostbaseUrl+functionName,data,{headers: headers}).subscribe(
               responsedata => {
                let response:any =responsedata
                if(response.code == 401){
                  sessionStorage.clear() 
                  window.location.replace('/login');
                }else{
                  resolve(response) 
                  
                }
                 
               },
               error => {
                resolve(error.message)
               }
             );
           });
    }
    public uploadBackMethod(functionName:any,data: any) {
      const headers = new HttpHeaders(
        {
        'Accept':'application/json',
        'Authorization': ''+sessionStorage.getItem('auth_token')
        }
        );
        return new Promise( async(resolve, reject) => {
          
            await this.httpClient.post(this.baseUrl+functionName,data,{headers: headers}).subscribe(
               responsedata => {
                let response:any =responsedata
                if(response.code == 401){
                  sessionStorage.clear() 
                  window.location.replace('/login');
                }else{
                  resolve(response) 
                  
                }
                 
               },
               error => {
                resolve(error.message)
               }
             );
           });
    }
}
